import { defineElement, html } from '@webtides/element-js';
import { classMap } from 'lit-html/directives/class-map.js';
import ColorButton from '../color-button/color-button.class';
import style from './color-button-toggle.css';

class ColorButtonToggle extends ColorButton {
    constructor() {
        super({ shadowRender: false, styles: [style] });
    }

    template() {
        const btnClasses = {
            'is-active': this.active,
            'is-disabled': this.disabled,
        };
        return html`
            <button
                title="${this.label}"
                class="btn btn-toggle px-0 w-12 items-center justify-center ${classMap(btnClasses)}"
                ?disabled="${this.disabled && this.renderDisabledAttribute}"
            >
                <div class="outer-circle relative rounded-full border-white border-2 h-10 w-10">
                    <div class="inner-circle rounded-full absolute inset-0"></div>
                </div>
            </button>
            ${this.getLabel()}
        `;
    }
}

defineElement('color-button-toggle', ColorButtonToggle);
